module.exports = __webpack_public_path__ + "img/logo.eff35d3b.png";